module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.acordos.length > 0) ? _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('a', {
    attrs: {
      "name": "listaAR"
    }
  }), _c('li', {
    staticClass: "prod"
  }, [_vm._v("Acordos Operacionais entre AR's")]), _vm._v(" "), _vm._l((_vm.acordos), function(acordo) {
    return _c('li', [_c('a', [_vm._v(_vm._s(_vm.ars[acordo.ar1].nome) + " - " + _vm._s(_vm.ars[acordo.ar2].nome))]), _vm._v(" "), _c('span', [_vm._v("\n        Período: " + _vm._s(acordo.periodo.inicio) + " a " + _vm._s(acordo.periodo.fim) + ".\n        "), (_vm.ars[acordo.ar1].descredenciada || _vm.ars[acordo.ar2].descredenciada) ? _c('em', [_c('br'), _vm._v("(acordo encerrado no descredenciamento)\n        ")]) : _vm._e()])])
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-094497cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RepositorioAcordo.vue
// module id = 91
// module chunks = 0